<template>
  <BaseTableView :head="tableHead" :class="$vuetify.breakpoint.xlOnly ? 'table' : ''">

    <template v-for="(item, key) in items">
      <ProjectReportsTableItem
          :item="item"
          :key="key"
          :click-line="openReportDataTable"
          :open-modal="openReportDataModal"
          :data-opened="showReportData === item.id"
          :min-table="minTable"
      />
      <tr v-if="$vuetify.breakpoint.xlOnly" :key="'reportData' + key" class="rel">
        <td v-if="showReportData === item.id && reportData.length > 0" colspan="9" class="pt-0 pl-15 pr-0 bills">
          <v-expand-transition>
            <v-card v-show="expand" tile flat>
              <BaseTableView :head="reportDataHead">
                <ProjectReportsEmailTable
                    v-for="(reportItem, j) in reportData"
                    :attached-reports="reportItem"
                    :key="'reportItem' + j"
                    :parent-report-id="showReportData"
                    :project-id="item.project.id"
                />
              </BaseTableView>
            </v-card>
          </v-expand-transition>
        </td>
      </tr>
    </template>
    <v-dialog v-if="modal" v-model="modal" width="600">
      <v-card class="px-4 py-12 pa-md-10">
        <v-btn icon text absolute right top @click="modal = false" class="ma-n1">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div v-if="reportData && reportData.length > 0">
          <ProjectReportsEmailTable
              v-for="(reportItem, j) in reportData"
              :attached-reports="reportItem"
              :key="'reportModal' + j"
              :parent-report-id="showReportData"
              :project-id="projectId"
              min-table
          />
        </div>
        <Plug v-else/>
      </v-card>
    </v-dialog>
  </BaseTableView>
</template>

<script>
import Plug from '../../Plug.vue'
import BaseTableView from "components/base/tableview/BaseTableView.vue";
import ProjectReportsTableItem from "components/project/projectReports/ProjectReportsTableItem.vue";
import ProjectReportsEmailTable from "components/project/projectReports/ProjectReportsEmailTable.vue";
import {mapActions} from 'vuex';

export default {
  name: "ProjectReportsTable",
  components: {ProjectReportsEmailTable, ProjectReportsTableItem, BaseTableView, Plug},
  props: {
    items: [Array, Object],
  },
  data: () => ({
    reportData: null,
    showReportData: -1,
    expand: false,
    modal: false,
    projectId: {},
  }),
  computed: {
    minTable() {
      return this.$vuetify.breakpoint.lgAndDown
    },
    tableHead() {
      return [
        {text: this.localStorage.translations.pages.projects['reports_table'].project},
        {text: this.localStorage.translations.pages['sales_project']['project_client-labels'].klient},
        {text: this.localStorage.translations.pages.projects['reports_table'].period},
        {text: this.localStorage.translations.pages.projects['reports_table']['week_number']},
        {
          text: this.localStorage.translations.pages.projects['reports_table']['date_create'],
          sort: {
            name: 'created_at',
            value:
              this?.$route?.query.sort_param === 'created_at' ? (this?.$route?.query.sort_value === 'desc' ? 'asc' : 'desc') : 'desc',
          },
        },
        {text: '', active: true},
      ]
    },
    reportDataHead() {
      return [
        {text: this.localStorage.translations.pages.projects['reports_table']['sent-date']},
        {text: this.localStorage.translations.pages.projects['reports_table']['received-date']},
      ]
    },
  },
  methods: {
    ...mapActions('workClientProjectsClientReports', ['onWorkClientProjectsClientReportsBillGrid']),
    async openReportDataTable(id, dontclose) {
      this.expand = false
      if (this.showReportData === id && !dontclose) this.showReportData = -1
      else await this.onWorkClientProjectsClientReportsBillGrid({report: id}).then(res => {
        this.reportData = res.data.data
        this.showReportData = id
        setTimeout(() => {
          this.expand = true
        }, 0)
      })
    },
    async openReportDataModal(id, projId) {
      await this.onWorkClientProjectsClientReportsBillGrid({report: id}).then(res => {
        this.reportData = res.data.data
        this.showReportData = id
        this.projectId = projId
        setTimeout(() => {
          this.modal = true
        }, 0)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.rel {
  border: none !important;
  min-height: 0 !important;

  &:hover {
    background-color: transparent !important;
  }
}

.table {
  thead {
    z-index: 3 !important;
  }
}

.bills {
  border-left: none !important;
  border-right: none !important;
}
</style>